$(document).ready(function () {
  checkBackToTop('#products-list', '#filters');

  // ======== Form inputs validation ========
  $('.form-control[required]').not('.ignore').keyup(function () {
    if ((this.validity.typeMismatch === true || this.validity.patternMismatch === true) && this.validity.valid === false) {
      if (this.type == 'email') {
        this.setCustomValidity('Въведете правилен Email!');
      }
      return
    }
    if (this.validity.valid !== false || this.value != '') {
      this.setCustomValidity('')
    } else {
      this.setCustomValidity('Полето е задължително!');
    }
  })
  $('.form-control[required]').not('.ignore').each(function () {
    if (this.validity.valid === false) {
      this.setCustomValidity('Полето е задължително!');
    }
  })

  // $('form').submit(function () {
  //   $('input.form-control[required]').not('.ignore').each(function () {
  //     if (this.validity.valid === false) {
  //       this.setCustomValidity('Полето е задължително!');
  //     }
  //     setTimeout(() => {
  //       this.setCustomValidity('');
  //     }, 1000)
  //   })
  // })
  // ======== Form inputs validation ======== //

  // $('[data-toggle="tooltip"]').tooltip()


        $(document).on('change', '#close_check', function(e){
          var close_check = $('#close_check:checked').length;
          if (close_check == 1) {
            $('.btn-close').removeClass('disabled').removeAttr('disabled');
          }else{
            $('.btn-close').addClass('disabled').attr('disabled', 'disabled');
          }
        });

        var myLazyLoad = new LazyLoad({
          elements_selector: ".lazy",
          load_delay: 300 //adjust according to use case
        });
      });


      $(function(){
  var Cookies = require('js-cookie');

  $('.js-accept-cookie, .js-refuse-cookie').click(function(e){
    e.preventDefault();
    Cookies.set('cookies', 'hidden');
    $('.cookies-info').css('display', 'none');
  });

  var cookies = Cookies.get('cookies');
  if(cookies != 'hidden'){
    $('.cookies-info').css('display', '').removeClass('d-none');
  }else{
    $('.cookies-info').css('display', 'none');

  }


  $(document).on('click', '.js-modal-save', function(){
    $('#cookieModal').modal('toggle');
    Cookies.set('cookies', 'hidden');
    $('.cookies-info').css('display', 'none');
});
});

// $('.cookies-info').on('click', function(e){
//   var target  = $(e.target);
//   if( target.is('a') ) {

//   }else{
//     Cookies.set('cookies', 'hidden');
//     $('.cookies-info').css('display', 'none');
//   }
// });
